export class WebCoreConstans {
    public static readonly REPORT_ALL_ERROR_EVENT = 'REPORT_ALL_ERROR_EVENT';
    public static readonly DIAGNOSTIC_REPORT_ALL_ERRORS = 'DIAGNOSTIC_REPORT_ALL_ERRORS';
}
